import script from "./AppTable.vue?vue&type=script&setup=true&lang=js"
export * from "./AppTable.vue?vue&type=script&setup=true&lang=js"

import "./AppTable.vue?vue&type=style&index=0&id=1beeae4a&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1beeae4a"]])

export default __exports__